<template>
  <div
    class="container"
    :style="{
      transform: `scale(${scale})`,
      transformOrigin: '0px 0px',
      'max-width': width + 'px',
      width: width + 'px',
      'max-height': height + 'px',
      height: height + 'px',
    }">
    <div class="title">
      <div style="width: 130px">
        <div class="back" @click="goback">
          <img src="../assets/bigData/home.png" alt="" />
          <span>返回首页</span>
        </div>
      </div>
      <div class="titText">
        {{ mapSelectCity
        }}{{
          cityDetail.homeTitle
            ? cityDetail.homeTitle
            : '农村集体财产监督管理平台'
        }}
      </div>
      <div style="width: 130px"></div>
    </div>
    <div class="content">
      <div class="row">
        <div style="flex: 2">
          <div class="pictitle">交易分类比重</div>
          <div id="jyflbz" style="height: 100%"></div>
        </div>
        <div style="flex: 3">
          <div class="pictitle">类别交易排行</div>
          <div id="lbjyph" style="height: 100%"></div>
        </div>
        <div style="flex: 3">
          <div class="pictitle">近7个月交易额走势</div>
          <div id="jgyjyezs" style="height: 100%"></div>
        </div>
      </div>
      <div class="centerRow" style="">
        <div class="detailContent">
          <div
            class="detailItem"
            v-for="(item, index) in detailContent"
            :key="index">
            <img :src="item.img" alt="" />
            <span class="detailItemTitle">{{ item.title }}</span>
            <div class="number">
              <count-to
                class="num"
                :start-val="startVal"
                :decimals="item.decimals"
                :end-val="+item.number"
                :duration="duration"
                >{{ item.num }}</count-to
              >
              <span class="unit">{{ item.unit }}</span>
            </div>
          </div>
        </div>
        <div :style="{ height: mapheight + 'px !important' }" style="flex: 4">
          <div id="map" style="width: 100%; height: 100%"></div>
        </div>
      </div>
      <div class="row">
        <div style="flex: 1; min-height: 246px">
          <div class="pictitle">交易分类前四</div>
          <div id="jyflqs" style="height: 100%">
            <div
              class="jyflItem"
              v-for="(item, index) in jyflList"
              :key="index"
              v-if="item.value">
              <div class="img">
                <img :src="item.src" alt="" />
              </div>
              <div class="msg">
                <div class="title">{{ item.title }}</div>
                <div class="num">
                  <count-to
                    :start-val="startVal"
                    :end-val="+item.value"
                    :duration="duration"
                    >{{ item.value }}</count-to
                  >笔
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="flex: 2">
          <!-- <div class="pictitle">
            交易{{ mapSelectCity == cityDetail.cityName ? "县区" : "乡镇" }}排行
          </div> -->

          <div class="pictitle">交易地区排行</div>
          <div id="jyxqph">
            <div
              class="jyquItem"
              v-for="(item, index) in jyquList"
              :key="index">
              <div class="index" v-if="index < 3">
                <img
                  src="../assets//bigData/first.png"
                  alt="1"
                  v-if="index == 0" />
                <img
                  src="../assets//bigData/second.png"
                  alt="2"
                  v-if="index == 1" />
                <img
                  src="../assets//bigData/third.png"
                  alt="3"
                  v-if="index == 2" />
              </div>
              <div class="index" v-if="index > 2">
                {{ index + 1 }}
              </div>

              <div class="name" :title="item.name">
                {{ item.name }}
              </div>
              <div class="long">
                <div
                  class="longCenter"
                  :style="{
                    width:
                      (Number(item.value) / Number(jyquMaxNumber)) * 100 + '%',
                  }"></div>
              </div>
              <div class="num">
                <count-to
                  :start-val="startVal"
                  :end-val="+item.value"
                  :duration="duration"
                  >{{ item.value }}</count-to
                >
              </div>
            </div>
          </div>
        </div>
        <div style="flex: 1">
          <div class="pictitle">实时数据</div>
          <div class="sssj">
            <vue-seamless-scroll
              :class-option="{ step: 0.6 }"
              :data="sssjData"
              class="warp">
              <ul class="sssjList">
                <li
                  class="sssjItem"
                  v-for="(item, index) in sssjData"
                  :key="index">
                  <img src="@/assets/img/shishiImg.png" alt="" />
                  <span class="news">
                    {{
                      item.dept_name +
                      (cityDetail.cityName == '卢氏县' ? '' : '交易市场') +
                      '，交易金额' +
                      item.deal_total +
                      '元'
                    }}
                  </span>
                </li>
              </ul>
            </vue-seamless-scroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CountTo from 'vue-count-to'
import { cityDetail } from '../util/mainOption'
import echarts from 'echarts'
import scroll from 'vue-seamless-scroll'
import vueSeamlessScroll from 'vue-seamless-scroll'
import {
  transTypeAmount,
  transTypeRate,
  amountMon,
  transIndicator,
  tansDeptOrder,
  transData,
} from '../api/大数据'
import { getTownList } from '../api/Head'
export default {
  components: {
    vueSeamlessScroll,
  },
  data() {
    return {
      scale: 1,
      width: '',
      height: '',
      mapheight: '',
      startVal: 0,
      duration: 2000,
      jyflListImgList: [
        require('../assets/bigData/img1.png'),
        require('../assets/bigData/img2.png'),
        require('../assets/bigData/img3.png'),
        require('../assets/bigData/img4.png'),
      ],
      jyflList: [],
      jyquList: [],
      jyquMaxNumber: 0,
      detailContent: [
        {
          title: '挂牌数量',
          number: '0',
          unit: '宗',
          img: require('@/assets/img/gpsl.png'),
          decimals: 0,
        },
        {
          title: '挂牌金额',
          number: '0',
          unit: '万元',
          img: require('@/assets/img/gpje.png'),
          decimals: 2,
        },
        {
          title: '成交数量',
          number: '0',
          unit: '宗',
          img: require('@/assets/img/cjsl.png'),
          decimals: 0,
        },
        {
          title: '成交金额',
          number: '0',
          unit: '万元',
          img: require('@/assets/img/cjje.png'),
          decimals: 2,
        },
        {
          title: '参与竞价总人数',
          number: '0',
          unit: '人',
          img: require('@/assets/img/qqcyjjzrs.png'),
          decimals: 0,
        },
      ],
      sssjData: [],
      mapSelectCity: '',
      mapCityList: [],
      cityPoint: {
        信阳市: [
          {
            name: '羊山新区',
            label: { position: 'left' },
            coord: [114.09, 32.13],
          },
          {
            name: '上天梯非金属矿管理区',
            coord: [114.25, 32.1],
            label: {
              position: 'right',
            },
          },
          {
            name: '金牛山管理区',
            coord: [114.05, 32.18],
            label: {
              position: 'left',
            },
          },
          {
            name: '高新区',
            coord: [114.18, 32.13],
            label: {
              position: 'bottom',
            },
          },
          {
            name: '工业城示范区',
            coord: [114.19, 32.15],
            label: {
              position: 'top',
            },
          },
        ],
        许昌市: [
          {
            name: '开发区',
            label: { position: 'left', fontSize: 16 },
            coord: [113.8, 34.0],
          },
          {
            name: '东城区',
            label: { position: 'right', fontSize: 16 },
            coord: [113.87, 34.01],
          },
          {
            name: '示范区',
            label: { position: 'top', fontSize: 16 },
            coord: [113.89, 34.11],
          },
        ],
      },
    }
  },
  created() {
    this.height = window.innerHeight
    this.width = window.innerWidth
    this.mapSelectCity =
      this.$route.query && this.$route.query.deptName
        ? this.$route.query.deptName
        : cityDetail.cityName
  },
  mounted() {
    console.log('cityDetail', cityDetail)
    this.mapSelectCity =
      this.$route.query && this.$route.query.deptName
        ? this.$route.query.deptName
        : cityDetail.cityName
    //  聂章帅 判断是否是乡镇
    getTownList(
      {},
      this.$route.query.deptId &&
        this.$route.query.deptCode &&
        this.$route.query.deptCode.length <= 6
        ? this.$route.query.deptId
        : cityDetail.deptId
    ).then((res) => {
      this.mapCityList = res.data.data.map((item) => {
        return {
          name: item.deptName,
          deptId: item.deptId,
        }
      })
      this.mapCityList.unshift({
        name:
          this.$route.query && this.$route.query.deptName
            ? this.$route.query.deptName
            : cityDetail.cityName,
        deptId: this.$route.query.deptId
          ? this.$route.query.deptId
          : cityDetail.deptId,
      })
      this.resize()
      window.addEventListener('resize', this.resize)

      this.mapLoad()
      this.mapClickLoad()
    })
  },
  methods: {
    // 获取百分比
    getPercentage(name, data) {
      let dataTotal = 0
      data.forEach((item) => {
        dataTotal += Number(item.value)
      })
      let checkData = data.find((item) => item.name == name)
      return checkData && dataTotal
        ? ((Number(checkData.value) / Number(dataTotal)) * 100).toFixed(2) + '%'
        : '0%'
    },
    getCityDetail(cityName) {
      console.log('this.mapSelectCity', this.mapSelectCity)
      console.log('cityName', cityName)
      console.log('mapCityList', this.mapCityList)
      return this.mapCityList.find((item) => item.name == cityName)
    },
    goback() {
      this.$router.push('/')
    },
    mapLoad() {
      let chartDom = document.querySelector('#map')
      let myChart = echarts.init(chartDom)
      let option
      console.log('this.$route.query.deptCode', this.$route.query.deptCode)
      // 聂章帅  判断是否是乡镇,是乡镇还调用区级地图
      if (
        this.$route.query.deptCode &&
        this.$route.query.deptCode.length <= 6
      ) {
        let geoJson = require(`../../public/41/${this.$route.query.deptCode}.json`)
        echarts.registerMap('cityMap', geoJson)
      } else {
        let geoJson = require(`../../public/41/${cityDetail.deptCode}.json`)
        echarts.registerMap('cityMap', geoJson)
      }

      myChart.on('click', (params) => {
        console.log('地图被点击', params)

        if (this.mapSelectCity == params.name) {
          myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: params.seriesIndex,
            name: this.mapSelectCity,
          })
          this.mapSelectCity =
            this.$route.query && this.$route.query.deptName
              ? this.$route.query.deptName
              : cityDetail.cityName
        } else {
          myChart.dispatchAction({
            type: 'downplay',
            seriesIndex: params.seriesIndex,
            name: this.mapSelectCity,
          })
          this.mapSelectCity = params.name
          myChart.dispatchAction({
            type: 'highlight',
            seriesIndex: params.seriesIndex,
            name: this.mapSelectCity,
          })
        }
        this.mapClickLoad()
        // myChart.clear()
        // myChart.setOption(option)
      })
      option = {
        title: {},
        tooltip: {
          trigger: 'item',
          showDelay: 0,
          transitionDuration: 0.2,
          show: false,
        },
        legend: {
          z: 2,
        },
        geo: {
          normal: {
            z: 3,
            areaColor: '#f0f0f0',
            borderColor: '#999',
          },
        },
        series: [
          {
            name: '',
            type: 'map',
            map: 'cityMap',
            projection: {
              project: function (point) {
                return projection(point)
              },
              unproject: function (point) {
                return projection.invert(point)
              },
            },
            emphasis: {
              label: {
                show: true,
              },
            },
            label: {
              show: true,
              color: '#fff',
              fontSize: 16,
            },
            data: this.mapCityList,
            itemStyle: {
              areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: '#2084F8' },
                { offset: 0.4, color: '#2084F8' },
                { offset: 1, color: '#1C68C1' },
              ]),
              borderColor: '#AFE9FA',
              borderWidth: 2,
            },
            emphasis: {
              label: {
                color: '#fff',
                fontSize: 16,
              },
              itemStyle: {
                areaColor: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#F6B858' },
                  { offset: 0.4, color: '#FA9E34' },
                  { offset: 1, color: '#FD7B00' },
                ]),
              },
            },
            markPoint: {
              show: true,
              symbol: 'pin', // 自定义图片路径
              label: {
                position: 'top',
                color: '#fff',
                fontSize: 16,
                formatter: '{b}',
              },
              symbolSize: 26,
              itemStyle: {
                color: '#fff',
              },
              emphasis: {
                itemStyle: {
                  color: '#FA9E34',
                },
                label: {
                  color: '#FA9E34',
                  fontWeight: '700',
                },
              },
              data: this.cityPoint[this.mapSelectCity] || [],
            },
          },
        ],
      }
      myChart.setOption(option)
    },
    mapClickLoad() {
      let deptId = this.getCityDetail(this.mapSelectCity).deptId
      this.jyflbzLoad()
      this.lbjyphLoad()
      this.jgyjyezsLoad()
      transIndicator({}, deptId).then((res) => {
        this.detailContent = this.detailContent.map((item, index) => {
          if (item.unit.indexOf('万') >= 0) {
            res.data.data[(index + 1).toString()] = (
              Number(res.data.data[(index + 1).toString()]) / 10000
            ).toFixed(item.decimals)
          }
          return {
            ...item,
            number: res.data.data[(index + 1).toString()],
          }
        })
      })
      tansDeptOrder({}, deptId).then((res) => {
        this.jyquList = res.data.data
        let maxVal = this.jyquList.length > 0 && this.jyquList[0].value
        this.jyquList.forEach((item) => {
          maxVal =
            Number(item.value) > Number(maxVal)
              ? Number(item.value)
              : Number(maxVal)
        })
        this.jyquMaxNumber = (Number(maxVal) * 1.1 + 1).toFixed(0)
      })
      transData({}, deptId).then((res) => {
        this.sssjData = res.data.data
      })
      transTypeRate({ top: 4 }, deptId).then((res) => {
        console.log(res.data.data)
        this.jyflList = res.data.data.map((item, index) => {
          return {
            ...item,
            value: item.value,
            title: item.name,
            src: this.jyflListImgList[index],
          }
        })
      })
    },
    resize() {
      let width = window.innerWidth
      let height = window.innerHeight
      if (
        (height == 1080 && width == 1920) ||
        (height == 919 && width == 1920)
      ) {
        this.scale = 1
        this.height = window.innerHeight
        this.width = window.innerWidth
        this.mapheight = height * 0.8 - 12
      } else if (width / this.width > height / this.height) {
        this.scale = height / this.height
      } else {
        this.scale = width / this.width
      }
    },
    jyflbzLoad() {
      let deptId = this.getCityDetail(this.mapSelectCity).deptId
      let data = { deptId, top: 15 }
      transTypeRate(data, deptId).then((res) => {
        let data = res.data.data
        var chartDom = document.getElementById('jyflbz')
        var myChart = echarts.init(chartDom)
        var option
        option = {
          tooltip: {
            trigger: 'item',
            formatter: '{b}:{c}笔',
          },
          color: ['#126DFF', '#35D4AB', '#FFA500', '#19A9FF', '#FF7C84'],
          legend: {
            orient: 'vertical',
            type: 'scroll',
            right: '0',
            top: 'center',
            itemWidth: 5,
            itemHeight: 5,
            borderRadius: 10,
            formatter: (name) => {
              return (
                (name.length > 10
                  ? name.slice(0, 10) + '\n' + name.slice(10)
                  : name) +
                ' ' +
                this.getPercentage(name, data)
              )
            },
            textStyle: {
              fontSize: 14,
            },
            itemGap: 16,
          },
          series: [
            {
              type: 'pie',
              radius: [30, 60],
              avoidLabelOverlap: false,
              center: ['30%', '55%'],
              itemStyle: {
                borderRadius: 8,
              },
              label: {
                show: true,
                position: 'center',
                formatter: '交易分类',
                color: '#666666',
                fontSize: 12,
              },
              emphasis: {
                label: {
                  show: false,
                  fontSize: 16,
                  fontWeight: 'bold',
                },
              },
              labelLine: {
                show: true,
              },
              // data: [
              //   { value: 40, name: '农村土地经营权', itemStyle: { color: "#126DFF" } },
              //   { value: 38, name: '林权', itemStyle: { color: "#35D4AB" } },
              //   { value: 32, name: '四荒地使用权', itemStyle: { color: "#FFA500" } },
              //   { value: 30, name: '农村集体经营性资产', itemStyle: { color: "#19A9FF" } },
              //   { value: 28, name: '农业生产设施设备', itemStyle: { color: "#FF7C84" } },
              // ],
              data: data,
            },
          ],
        }
        option && myChart.setOption(option)
      })
    },
    lbjyphLoad() {
      let deptId = this.getCityDetail(this.mapSelectCity).deptId
      let data = { deptId, top: 12 }
      transTypeAmount(data, deptId).then((res) => {
        let data = res.data.data.data
        let xAlias = res.data.data.xAlias
        var chartDom = document.getElementById('lbjyph')
        var myChart = echarts.init(chartDom)
        var option
        option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'shadow',
            },
            formatter: '{b}:{c}元',
          },
          dataZoom: [
            {
              // start: 0,//默认为0
              // end: 100,//默认为100
              type: 'slider',
              show: true,
              // xAxisIndex: [0],
              handleSize: 0, //滑动条的 左右2个滑动条的大小
              startValue: 0, // 初始显示值
              endValue: 8, // 结束显示值
              height: 10, //组件高度
              left: '5%', //左边的距离
              right: '4%', //右边的距离
              bottom: 0, //底边的距离
              borderColor: '#FFF',
              fillerColor: '#3D85FE',
              borderRadius: 5,
              backgroundColor: '#00000016', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
            },
            //下面这个属性是里面拖到
            {
              type: 'inside',
              show: true,
              // xAxisIndex: [0],
              start: 1, //默认为1
              end: 100, //默认为100
            },
          ],
          grid: {
            left: '10',
            right: '30',
            bottom: '3%',
            containLabel: true,
          },
          legend: {
            show: true,
          },
          xAxis: [
            {
              type: 'category',
              data: xAlias,
              axisTick: {
                alignWithLabel: true,
              },
              axisLabel: {
                formatter: function (value) {
                  return value.length > 5
                    ? value.slice(0, 5) + '\n' + value.slice(5, value.length)
                    : value
                },
                fontSize: 12,
              },
            },
          ],
          yAxis: [
            {
              type: 'value',
              axisLine: {
                show: false, // 这里设置为false，不显示y轴线
              },
              name: '元',
            },
          ],
          series: [
            {
              name: '交易额',
              type: 'bar',
              barWidth: '30%',
              data: data,
              itemStyle: {
                color: '#126DFF',
              },
            },
          ],
        }
        option && myChart.setOption(option)
      })
    },
    jgyjyezsLoad() {
      let deptId = this.getCityDetail(this.mapSelectCity).deptId
      let data = { deptId }
      amountMon(data, deptId).then((res) => {
        let data = res.data.data.data
        let xAlias = res.data.data.xAlias
        var chartDom = document.getElementById('jgyjyezs')
        var myChart = echarts.init(chartDom)
        var option
        option = {
          dataZoom: [
            {
              // start: 0,//默认为0
              // end: 100,//默认为100
              type: 'slider',
              show: true,
              // xAxisIndex: [0],
              handleSize: 0, //滑动条的 左右2个滑动条的大小
              startValue: 0, // 初始显示值
              endValue: 8, // 结束显示值
              height: 10, //组件高度
              left: '5%', //左边的距离
              right: '4%', //右边的距离
              bottom: 0, //底边的距离
              borderColor: '#FFF',
              fillerColor: '#3D85FE',
              borderRadius: 5,
              backgroundColor: '#00000016', //两边未选中的滑动条区域的颜色
              showDataShadow: false, //是否显示数据阴影 默认auto
              showDetail: false, //即拖拽时候是否显示详细数值信息 默认true
              realtime: true, //是否实时更新
              filterMode: 'filter',
            },
            //下面这个属性是里面拖到
            {
              type: 'inside',
              show: true,
              // xAxisIndex: [0],
              start: 1, //默认为1
              end: 100, //默认为100
            },
          ],
          grid: {
            left: '10',
            right: '30',
            bottom: '3%',
            top: '40',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAlias,
            axisLabel: {
              formatter: function (value) {
                return value
              },
              fontSize: 14,
            },
            axisLine: {
              show: false, // 这里设置为false，不显示y轴线
            },
          },
          yAxis: {
            type: 'value',
            name: '元',
            axisLine: {
              show: false, // 这里设置为false，不显示y轴线
            },
          },
          tooltip: {
            trigger: 'axis',
            formatter: '2024年{b}<br />交易额:{c}元',
          },
          legend: {
            show: true,
          },
          series: [
            {
              name: '交易额',
              data: data,
              type: 'line',
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: '#4A9DFF' },
                  { offset: 0.8, color: '#DAEBFF' },
                  { offset: 1, color: '#ffffff' },
                ]), // 区域填充颜色，带有半透明效果
              },
              lineStyle: {
                color: '#2187FF',
              },
              itemStyle: {
                color: '#2187FF',
              },
            },
          ],
        }

        option && myChart.setOption(option)
      })
    },
  },
}
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

img {
  display: inline-block;
}

.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px 20px;
  background: url('../assets/img/bigDataBg.png') no-repeat;
  background-size: 100% 100%;

  .title {
    height: 70px;
    line-height: 70px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    .back {
      display: flex;
      align-items: center;
      border: 1px solid #85bdff;
      border-radius: 6px;
      padding: 7px 10px;
      width: 130px !important;
      height: 44px;
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      span {
        font-family: MicrosoftYaHei;
        color: #2187ff;
        font-weight: 400;
        font-size: 16px;
      }
    }
    .titText {
      font-family: SourceHanSansSC;
      font-weight: 700;
      font-size: 64px;
      letter-spacing: 2px;
      background: -webkit-linear-gradient(
        270deg,
        rgb(70, 213, 255) 0%,
        rgb(0, 118, 255) 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent; /*
      text-shadow: 0px 1px 1px rgba(0, 118, 255, 1),
        1px 3px 1px rgba(55, 147, 252, 0.8), 1px 5px 1px rgba(55, 147, 252, 0.8),
        1px 7px 6px rgba(10, 10, 10, 0.4), 1px 9px 6px rgba(10, 10, 10, 0.2),
        1px 11px 10px rgba(10, 10, 10, 0.2), 1px 13px 35px rgba(10, 10, 10, 0.2),
        1px 15px 60px rgba(10, 10, 10, 0.2);
      text-shadow: 0px 1px 0px rgba(0, 118, 255, 1),
        1px 3px 0px rgba(55, 147, 252, 0.6), 1px 5px 0px rgba(55, 147, 252, 0.6),
        1px 7px 0px rgba(55, 147, 252, 0.6);*/
      display: inline-block;
      text-align: center;
    }
  }

  .content {
    flex: 1;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 2fr 1fr;
    grid-column-gap: 12px;

    .row {
      height: 100%;
      align-items: center;
      display: flex;
      flex-direction: column;

      & > div {
        width: 100%;
        max-height: 100%;
        margin: 6px 0;
        padding: 14px 30px;
        box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
        border-radius: 10px;
        display: flex;
        flex-direction: column;

        .pictitle {
          font-family: MicrosoftYaHei;
          color: #262626;
          font-weight: 400;
          font-size: 20px;
        }

        #jyflqs {
          width: 100%;
          height: auto;
          display: flex;
          flex-flow: row wrap;
          justify-content: space-between;
          align-items: center;

          .jyflItem {
            width: 50%;
            height: auto;
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;

            .img {
              width: 100px;
              height: 96px;

              img {
                width: 100%;
                height: 100%;
              }
            }

            .msg {
              flex: 1;
              height: auto;
              display: flex;
              flex-flow: column nowrap;
              justify-content: flex-start;
              align-items: flex-start;
              box-sizing: border-box;

              .title {
                width: 100%;
                height: 21px;
                line-height: 21px;
                font-family: MicrosoftYaHei;
                color: #262626;
                font-weight: 400;
                font-size: 16px;
                overflow: hidden;
                margin: 0 0 6px 0;
              }

              .num {
                width: 100%;
                height: auto;
                color: #666666;
                font-weight: 400;
                font-size: 12px;

                span {
                  line-height: 31px;
                  color: #262626;
                  font-weight: 400;
                  font-size: 24px;
                }
              }
            }
          }
        }

        #jyxqph {
          width: 100%;
          height: 28vh;
          max-height: 28vh;
          overflow-y: scroll;
          display: flex;
          flex-flow: column nowrap;
          justify-content: flex-start;
          box-sizing: border-box;
          margin: 10px 0 0 0;

          &::-webkit-scrollbar {
            width: 0;
            height: 0;
          }

          .jyquItem {
            width: 100%;
            height: auto;
            display: flex;
            flex-flow: row nowrap;
            justify-content: flex-start;
            align-items: center;

            .index {
              width: 30px;
              height: auto;
              color: #2187ff;
              font-weight: 400;
              font-size: 14px;
              line-height: 36px;
              text-align: center;

              img {
                width: 18px;
                height: 17px;
              }
            }

            .name {
              width: 80px;
              color: #262626;
              font-weight: 400;
              font-size: 16px;
              line-height: 24px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            .long {
              flex: 1;
              height: 14px;
              border: 1px solid rgba(0, 150, 255, 0.6);
              border-radius: 14px;
              display: flex;
              flex-flow: row nowrap;
              justify-content: flex-start;
              align-items: center;
              padding: 2px;

              .longCenter {
                width: auto;

                height: 8px;
                border-radius: 8.5px;
                background: linear-gradient(
                  270deg,
                  rgba(69, 188, 255, 1) 0%,
                  rgba(33, 135, 255, 1) 100%
                );
              }
            }

            .num {
              width: auto;
              color: #262626;
              font-weight: 400;
              font-size: 16px;
              line-height: 24px;
              margin-left: 10px;
              width: 30px;
            }
          }
        }
        .sssj {
          height: 20vh;
          max-width: 100%;
          .warp {
            overflow: hidden;
            max-height: 20vh;
            max-width: 100%;
            .sssjList {
              max-width: 100%;
              .sssjItem {
                max-width: 100%;
                display: flex;
                align-items: center;
                padding: 10px 0;
                img {
                  width: 12px;
                  height: 14px;
                }
                .news {
                  max-width: 430px;
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                }
              }
            }
          }
        }
      }
    }

    .centerRow {
      height: 100%;
      align-items: center;
      display: flex;
      flex-direction: column;

      & > div {
        width: 100%;
        height: 100%;
        flex: 1;
        margin: 6px 0;
      }
      .detailContent {
        display: flex;
        align-items: center;
        .detailItem {
          display: flex;
          flex-direction: column;
          flex-wrap: nowrap;
          flex: 1;
          align-items: center;
          img {
            width: 54px;
            height: 54px;
            margin-bottom: 10px;
          }
          .detailItemTitle {
            font-family: MicrosoftYaHei;
            color: #262626;
            font-weight: 400;
            font-size: 16px;
          }
          .number {
            margin-top: 12px;
            display: flex;
            align-items: end;
            .num {
              font-family: MicrosoftYaHeiUI;
              color: #2187ff;
              font-weight: 700;
              font-size: 26px;
            }
            .unit {
              margin-left: 6px;
              font-family: MicrosoftYaHei;
              color: #666666;
              font-weight: 400;
              font-size: 12px;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
}
</style>
